import React, { useEffect, useState } from 'react';

const FadeComponent = ({children, show}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!show) {
      setVisible(false);
      return;
    }
    const timer = setTimeout(() => setVisible(true), 300); // delay to allow transition
    return () => clearTimeout(timer);
  }, [show]);

  return (
    <div className={`fade ${visible ? 'show' : ''}`}>
      {children}
    </div>
  );
};

export default FadeComponent;
